import { render, staticRenderFns } from "./uploadImgJavaAdd.vue?vue&type=template&id=6a457f76&"
import script from "./uploadImgJavaAdd.vue?vue&type=script&lang=js&"
export * from "./uploadImgJavaAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports